var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFinishOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 4H6.27778C4.74444 4 3.5 5.49333 3.5 7.33333V12.6667C3.5 14.5067 4.74444 16 6.27778 16H15.1667C16.7 16 17.9444 14.5067 17.9444 12.6667V7.33333C17.9444 5.49333 16.7 4 15.1667 4ZM6.27778 5.33333H15.1667C16.0852 5.33333 16.8333 6.23111 16.8333 7.33333V7.55556H4.61111V7.33333C4.61111 6.23111 5.35926 5.33333 6.27778 5.33333ZM15.1667 14.6667H6.27778C5.35926 14.6667 4.61111 13.7689 4.61111 12.6667V8.88889H16.8333V12.6667C16.8333 13.7689 16.0852 14.6667 15.1667 14.6667Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49995 12H6.27772C5.97402 12 5.72217 12.3022 5.72217 12.6667C5.72217 13.0311 5.97402 13.3333 6.27772 13.3333H8.49995C8.80365 13.3333 9.0555 13.0311 9.0555 12.6667C9.0555 12.3022 8.80365 12 8.49995 12Z",
    fill: "#4C4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinishOrder);
export default __webpack_public_path__ + "static/media/ic_finish_order.547ba18a2503d8d729a7205ee42770df.svg";
export { ForwardRef as ReactComponent };